"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSpanVectorField = isValidSpanVectorField;
exports.isValidSpanTypeField = isValidSpanTypeField;
exports.createSpanTypeField = createSpanTypeField;
exports.isValidMidSpanIkePhotoField = isValidMidSpanIkePhotoField;
exports.hasCompleteSpanTypeState = hasCompleteSpanTypeState;
const core_api_1 = require("@ikegps/core-api");
const __1 = require("../..");
const integrations_1 = require("../../../pole/integrations");
const spanTypeOptions = {
    foreSpan: [
        integrations_1.IPFSpanType.FORE_SPAN, // IPF
        integrations_1.SpanType.NextPole, // DDS, OCalc, PoleForeman Legacy, Spida
    ],
    backSpan: [
        integrations_1.IPFSpanType.BACK_SPAN, // IPF
        integrations_1.SpanType.PreviousPole, // DDS, OCalc, PoleForeman Legacy, Spida
    ],
    otherSpan: [
        integrations_1.IPFSpanType.OTHER, // IPF
        integrations_1.SpanType.Other, // DDS, OCalc, PoleForeman Legacy, Spida
    ],
    buildingSpan: [
        integrations_1.SpanType.Building, // DDS, OCalc, PoleForeman Legacy, Spida
    ],
};
function isValidSpanVectorField(field) {
    return field.type === core_api_1.IkeFieldType.VECTOR;
}
function isValidSpanTypeField(field) {
    if (!__1.FormModelFieldSelectList.isSelectList(field)) {
        return false;
    }
    // Must include a valid Fore Span option.
    if (!field.options.some((option) => spanTypeOptions.foreSpan.find((valid) => valid === option.value))) {
        return false;
    }
    // Must include a valid Back Span option.
    if (!field.options.some((option) => spanTypeOptions.backSpan.find((valid) => valid === option.value))) {
        return false;
    }
    // Must include a valid Other Span option.
    if (!field.options.some((option) => spanTypeOptions.otherSpan.find((valid) => valid === option.value))) {
        return false;
    }
    return true;
}
function createSpanTypeField(mut) {
    const selectList = mut.create('selectlist');
    selectList.Mutator.option({ text: integrations_1.SPAN_TYPES[0].name, value: integrations_1.SPAN_TYPES[0].type }); // NEXT_POLE
    selectList.Mutator.option({ text: integrations_1.SPAN_TYPES[1].name, value: integrations_1.SPAN_TYPES[1].type }); // PREVIOUS_POLE
    selectList.Mutator.option({ text: integrations_1.SPAN_TYPES[2].name, value: integrations_1.SPAN_TYPES[2].type }); // OTHER_POLE
    selectList.Mutator.option({ text: integrations_1.SPAN_TYPES[3].name, value: integrations_1.SPAN_TYPES[3].type }); // BUILDING
    return selectList;
}
/**
 * Validates that a field can be used as a mid span IKE photo field.
 * Must be a TRUE_SIZE field type which stores CaptureFileJSONObject[].
 */
function isValidMidSpanIkePhotoField(field) {
    return field.type === core_api_1.IkeFieldType.TRUE_SIZE;
}
/**
 * Check if a span subform has complete type state for two-way linking.
 * Returns true if all required fields (vector, type, midSpanPhoto) are configured.
 *
 * @param schema The subform field to check
 * @returns true if the span has complete configuration for two-way linking
 */
function hasCompleteSpanTypeState(schema) {
    const state = schema.subFormSpanTypeState;
    if (!state)
        return false;
    return !!(state.vectorFieldId && state.typeFieldId && state.midSpanIkePhotoFieldId);
}
//# sourceMappingURL=form.subform.span.js.map